import * as yup from "yup";

export const defaultFormValues = {
  id: "",
  name: "",
  defaultTemplateTypeId: "",
  enabled: true,
  automaticallyPrint: false,
  terminalIds: [],
  filters: [],
};

export const schema = yup.object().shape({
  id: yup.string().optional(),
  name: yup.string().required("Name is required"),
  defaultTemplateTypeId: yup.string().optional(),
  enabled: yup.boolean().required("Enabled is required"),
  filters: yup
    .array()
    .of(
      yup.object().shape({
        type: yup.string().required("Type is required"),
        values: yup.array().of(
          yup.object().shape({
            value: yup.string().required("Value is required"),
          })
        ),
      })
    )
    .required("Filters is required"),
  automaticallyPrint: yup.boolean().required("Automatically Print is required"),
  terminalIds: yup.array().of(yup.string()).required("Terminal is required"),
});
